import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import ListItemText from '@mui/material/ListItemText';

import { fAPIDate } from 'src/utils/format-time';

import Label from 'src/components/label';

import { IDebtor } from 'src/types/cheque-factoring';

type Props = {
  row: IDebtor;
};

export default function DebtorTableRow({ row }: Props) {
  const { name, bank, payerAccountNumber, returnCount, lastReturnDate } = row;

  return (
    <TableRow hover>
      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
        <ListItemText
          primary={name}
          secondary={payerAccountNumber}
          primaryTypographyProps={{ typography: 'body2' }}
          secondaryTypographyProps={{
            component: 'span',
            color: 'text.disabled',
            typography: 'caption',
          }}
        />
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{bank}</TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
        {returnCount > 0 ? (
          <Label variant="soft" color="warning">
            {returnCount} return(s)
          </Label>
        ) : (
          <Label variant="soft" color="success">
            No returns
          </Label>
        )}
      </TableCell>

      <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
        {lastReturnDate ? fAPIDate(lastReturnDate) : '—'}
      </TableCell>
    </TableRow>
  );
}
